import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'alarm/';

class AlarmService {

    getBaliseAlarms(baliseId, offset, limit, startDate = null, endDate = null, alarmTypeIds = null) {

        var UrlToCall;
        UrlToCall = API_URL + 'getbalisealarms/' + baliseId + '?offset=' + offset + '&limit=' + limit;
        UrlToCall = (startDate != null) ? (UrlToCall + '&startDate=' + startDate) : UrlToCall;
        UrlToCall = (endDate != null) ? (UrlToCall + '&endDate=' + endDate) : UrlToCall;
        UrlToCall = (alarmTypeIds != null) ? (UrlToCall + '&alarmTypeIds=' + alarmTypeIds.join(',')) : UrlToCall;

        return axios.get(UrlToCall, { headers: authHeader() });
    }

    getBadgeAlarms(badgeNumber, offset, limit, startDate = null, endDate = null) {

        var UrlToCall;
        UrlToCall = API_URL + 'getbadgealarms/' + badgeNumber + '?offset=' + offset + '&limit=' + limit;
        UrlToCall = (startDate != null) ? (UrlToCall + '&startDate=' + startDate) : UrlToCall;
        UrlToCall = (endDate != null) ? (UrlToCall + '&endDate=' + endDate) : UrlToCall;

        return axios.get(UrlToCall, { headers: authHeader() });
    }

    getClientAlarms(clientId, offset, limit, startDate = null, endDate = null) {

        var UrlToCall;
        UrlToCall = API_URL + 'getclientalarms2/' + clientId + '?offset=' + offset + '&limit=' + limit;
        UrlToCall = (startDate != null) ? (UrlToCall + '&startDate=' + startDate) : UrlToCall;
        UrlToCall = (endDate != null) ? (UrlToCall + '&endDate=' + endDate) : UrlToCall;

        return axios.get(UrlToCall, { headers: authHeader() });
    }

    getAlarmTypes() {
        return axios.get(API_URL + 'types', { headers: authHeader() });
    }

    // Admin - search alarms with filters
    // alarmTypeIds: array of ids (e.g. [1,2,5]) OR comma-separated string "1,2,5"
    // clientId / baliseId optional
    // startDate / endDate optional
    // if no dates provided: backend returns last 100 alarms by default
    searchAlarms({ clientId = null, baliseId = null, alarmTypeIds = null, startDate = null, endDate = null, offset = 0, limit = 100, signal = null } = {}) {
        let UrlToCall = API_URL + 'search?offset=' + offset + '&limit=' + limit;

        UrlToCall = (clientId != null) ? (UrlToCall + '&clientId=' + clientId) : UrlToCall;
        UrlToCall = (baliseId != null) ? (UrlToCall + '&baliseId=' + baliseId) : UrlToCall;

        if (alarmTypeIds != null) {
            const value = Array.isArray(alarmTypeIds) ? alarmTypeIds.join(',') : alarmTypeIds;
            UrlToCall = (String(value).trim() !== '') ? (UrlToCall + '&alarmTypeIds=' + value) : UrlToCall;
        }

        UrlToCall = (startDate != null) ? (UrlToCall + '&startDate=' + startDate) : UrlToCall;
        UrlToCall = (endDate != null) ? (UrlToCall + '&endDate=' + endDate) : UrlToCall;

        return axios.get(UrlToCall, {
            headers: authHeader(),
            signal
        });
    }

}

export default new AlarmService();